import { Controller, useFormContext } from 'react-hook-form'

import { CurrencyCentInput, FF2, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

type WiresInProps = {
  index: number
}

export const WiresIn = ({ index }: WiresInProps) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`transactionsInfo.${index as 0}.wiresIn`}
      control={control}
      rules={{ validate: (value) => Validators.required.notEmpty(value) }}
      render={({ field }) => (
        <FF2 required field={field} label="Wires In" input={(props) => <CurrencyCentInput {...props} />} />
      )}
    />
  )
}
